import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SwMessageModule } from '../sw-message/sw-message.module';
import { SwTreeService } from './sw-tree.service';
import { SwTreeNodeComponent } from './sw-tree-node/sw-tree-node.component';
import { SwTreeComponent } from './sw-tree.component';

@NgModule({
  imports: [CommonModule, SwMessageModule],
  declarations: [SwTreeNodeComponent, SwTreeComponent],
  exports: [SwTreeNodeComponent, SwTreeComponent],  
  providers: [SwTreeService],
  entryComponents: []
})
export class SwTreeModule {
  
}